<template>
  <div class="areastatic">
    <div class="opertioncontainer">
      <ul class="optionBox">
        <li>
          <span class="tit">开始时间：</span>
          <div class="inputbox">
            <time-selct :value.sync="startTime"></time-selct>
          </div>
        </li>
        <li>
          <span class="tit">截止时间：</span>
          <div class="inputbox">
            <time-selct :value.sync="endTime"></time-selct>
          </div>
        </li>
        <li>
          <span class="tit">订单编号：</span>
          <div class="inputbox">
            <span class="inp">
              <input type="text" v-model="orderNumber" placeholder="请输入订单编号">
            </span>
          </div>
        </li>
        <li>
          <span class="tit">游戏账号：</span>
          <div class="inputbox">
            <span class="inp">
              <input type="text" v-model="playerAccount" placeholder="请输入游戏编号">
            </span>
          </div>
        </li>
        <li>
          <span class="tit">订单状态：</span>
          <div class="inputbox clearfix">
            <slector style="width:110px;float:left" title="订单状态" :columns="state" :value.sync="orderState"></slector>
            <van-button size="small" color="linear-gradient(to bottom, #3de9a9, #23cc9a)" @click="checkdata"><span class="pdl10 pdr10">查询</span></van-button>
          </div>
        </li>
      </ul>
    </div>
    <div class="contentbox">
      <div class="container">
        <ul class="topBox">
          <li>
            <span class="td1">下单时间</span>
            <span class="td2">订单号</span>
            <span class="td3">金额</span>
            <span class="td4">游戏账号</span>
            <span class="td5">状态</span>
          </li>
        </ul>
        <van-divider dashed v-if="list.length ===0">暂无数据</van-divider>
        <div class="tableCont" v-else>
          <van-pull-refresh class="scrolldiv" v-model="refreshing" @refresh="onRefresh">
            <van-list v-model="loading" :offset="80" :immediate-check="false" :finished="finished" finished-text="我是有底线的" @load="onLoad">
              <ul>
                <li v-for="(item,i) in list" :key="'list'+i">
                  <span class="td1">
                    <i class="time">{{item.orderDate.split(' ')[0]}} <br><em>{{item.orderDate.split(' ')[1]}}</em></i>
                  </span>
                  <span class="td2">{{item.orderNumber}}</span>
                  <span class="td3">{{item.amount}}</span>
                  <span class="td4">{{item.playerAccount}}</span>
                  <span class="td5">{{item.state|orderStates}}</span>
                </li>
              </ul>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import timeSelct from '../components/timeSelct1';
import slector from '../components/slector1';
export default {
  components: {
    timeSelct,
    slector
  },
  data() {
    return {
      list: [],
      state: [
        { text: '全部', value: -1 },
        { text: '成功', value: 1 },
        { text: '待发送', value: 2 },
        { text: '待付款', value: 0 }
      ],
      startTime: '',
      endTime: '',
      orderNumber: '',
      playerAccount: '',
      orderState: -1,
      loading: false,
      finished: false,
      refreshing: false,
      PageNumber: 1,
      PageSize: 20,
      total: 0
    };
  },
  filters: {
    orderStates: function(data) {
      let state = '';
      switch (data) {
        case 0:
          state = '待付款';
          break;
        case 1:
          state = '成功';
          break;
        case 2:
          state = '待下发';
          break;
        case 3:
          state = '退款';
          break;
      }
      return state;
    }
  },
  methods: {
    getlist() {
      this.$api.home
        .orderInfo({
          StartOrderDate: this.startTime,
          EndOrderDate: this.endTime,
          OrderNumber: this.orderNumber,
          PlayerAccount: this.playerAccount,
          GroupId: '',
          PartitionId: '',
          PartitionName: '',
          ProductId: '',
          StartAmount: '',
          EndAmount: '',
          State: this.orderState,
          uuid: this.$route.query.uuid,
          PageNumber: this.PageNumber,
          PageSize: this.PageSize
          // uuid: '45931388ed964ab2a06f8446ce98cf36'
        })
        .then((data) => {
          if (data.status === 200) {
            if (this.PageNumber === 1) {
              this.list = data.data;
            } else {
              this.list = this.list.concat(data.data);
            }
            this.total = JSON.parse(data.headers['x-pagination']).TotalCount;
            if (this.list.length >= this.total) {
              this.finished = true;
            } else {
              this.finished = false;
              this.loading = false;
              this.PageNumber++;
            }
            this.refreshing = false;
          } else {
            this.list = [];
            this.refreshing = false;
            this.finished = false;
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$toast(err.message);
        });
    },
    // 下拉刷新
    onRefresh() {
      this.PageNumber = 1;
      this.finished = false;
      this.getlist();
    },
    // 上拉加载
    onLoad() {
      if (this.finished) {
        return;
      }
      this.getlist();
    },
    // 查询数据
    checkdata() {
      this.loading = false;
      this.finished = false;
      this.refreshing = false;
      this.PageNumber = 1;
      this.list = [];
      this.getlist();
    }
  },
  created() {
    this.getlist();
  }
};
</script>

<style lang="scss" scoped>
.areastatic {
  position: relative;
  padding-top: 240px;
  height: 100%;
  // background: url(../assets/images/bg.jpg) no-repeat center top;
  background-size: 100% auto;
  .opertioncontainer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 240px;
    padding-bottom: 15px;
    .optionBox {
      padding-top: 30px;
      li {
        margin-bottom: 10px;
        text-align: center;
        .tit {
          display: inline-block;
          vertical-align: middle;
          font-size: 17px;
          color: #727272;
          width: 88px;
        }
        .inputbox {
          display: inline-block;
          vertical-align: middle;
          width: 200px;
          .inp {
            display: inline-block;
            margin-right: 10px;
            background: #fff;
            border-radius: 4px;
            color: #b1b1b1;
            font-size: 14px;
            input {
              display: block;
              border: none;
              outline: none;
              width: 100px;
              height: 30px;
              padding: 0 10px;
              width: 100%;
              border-radius: 4px;
              border: 1px solid #dbd8d8;
              &:focus {
                border-color: #1abc9c;
              }
              &::placeholder {
                color: #bbb;
              }
            }
          }
        }
      }
    }
    .btnbox {
      text-align: center;
      margin-top: 20px;
      .icon_btn {
        display: inline-block;
        width: 100px;
        height: 30px;
        background: url(../assets/images/btns.png) no-repeat center center;
        background-size: 100% auto;
      }
    }
  }
  .contentbox {
    height: 100%;
    margin: 0 15px;
    text-align: center;
    padding-bottom: 30px;
    .container {
      position: relative;
      padding-top: 38px;
      background: #fff;
      border: 1px solid #c6c6c6;
      height: 100%;
      background: #fff;
      // overflow-y: auto;
      .topBox {
        position: absolute;
        height: 38px;
        top: 0;
        left: 0;
        width: 100%;
        li {
          display: flex;
          flex-flow: row nowrap;
          span {
            padding: 0 5px;
            height: 38px;
            line-height: 38px;
            font-size: 15px;
            color: #646464;
            font-weight: bold;
            border-right: 1px solid #c6c6c6;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            word-break: break-all;
            border-bottom: 1px solid #c6c6c6;
            &.td1 {
              width: 23%;
            }
            &.td2 {
              width: 24%;
            }
            &.td3 {
              width: 18%;
            }
            &.td4 {
              width: 22%;
            }
            &.td5 {
              width: 18%;
              border-right: none;
            }
          }
        }
      }
      .tableCont {
        height: 100%;
        overflow-y: auto;
        // .scrolldiv {
        //   height:100%;
        // }
        ul {
          li {
            display: flex;
            flex-flow: row nowrap;
            &:nth-child(ODD) {
              background: #dce8fe;
            }
            span {
              padding: 0 5px;
              height: 38px;
              line-height: 38px;
              font-size: 14px;
              color: #262626;
              // font-weight: bold;
              border-right: 1px solid #c6c6c6;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              word-break: break-all;
              border-bottom: 1px solid #c6c6c6;
              font-size: 12px;
              .time {
                display: block;
                padding-top: 5px;
                line-height: 15px;
                // font-size: 12px;
                em {
                  color: #5b5b5b;
                }
              }
              &.td1 {
                width: 23%;
              }
              &.td2 {
                width: 24%;
                white-space: normal;
                line-height: 15px;
                padding-top: 4px;
              }
              &.td3 {
                width: 18%;
              }
              &.td4 {
                width: 22%;
              }
              &.td5 {
                width: 18%;
                border-right: none;
              }
            }
          }
        }
      }
    }
  }
}
</style>
